import React from "react";
import { connect } from "react-redux";
import { Inventories } from "../../../components/inventory";
import { withRouter } from "../../../utils/withRouter";
import language from "../../../language";
import { Tabs } from "../../../components/Tabs";
import { getStorage } from "../../../utils/storage";
import accessMenu from "../../../utils/accessMenu";
import Controls from "../../../components/inventory/controls";
import DashboardInventories from "../../../components/inventory/dashboardInventory/index";
import CloserToExpiryDate from "../../../components/inventory/CloserToExpiryDate";

// Expired Products used to list only rows a nightly sweep had stamped
// status "expired". A unit that lapsed while still marked "labelled" was in
// no tab at all: the Inventory tab drops expired units, and Virtual Stock is
// superAdmin only. That is how 7247522/34051 became invisible to Nyagatare
// four hours after they received it.
//
// The tab now asks the date, not the stamp, so a unit appears the moment it
// expires, scoped to the facility that holds it. Anything that lapsed before
// this bound stays out of it and belongs to Virtual Stock, which carries no
// bound and is the catch-all; there are over sixteen thousand of those and
// dropping them in at once would bury what entities can still act on. Raise
// the bound once that backlog has been worked through.
const EXPIRED_PRODUCTS_FROM = "2026-10-12 00:00";

class InventoriesScreen extends React.Component {
  state = {
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });
  };
  render() {
    let { canReadProductionInventory } = accessMenu();
    let tabOptions = [];

    if (canReadProductionInventory) {
      tabOptions = [
        {
          title: language[this.props.defaultLanguage].dashboard,
          data: <DashboardInventories />,
        },
        {
          title: language[this.props.defaultLanguage].inventory,
          data: (
            <Inventories
              {...this.props.routeParams}
              isMainInventory={this.props.isMainInventory}
              status="labelled"
              // The cards already drop expired units, but the table under them
              // did not, so a unit that expired days ago still sat in the
              // Inventory listing while the counts above it ignored it.
              // Expired units belong in Virtual Stock and nowhere else.
              excludeExpired
            />
          ),
        },
        {
          title: language[this.props.defaultLanguage].closer_to_expiry_date,
          data: <CloserToExpiryDate {...this.props.routeParams} />,
        },
        {
          title: language[this.props.defaultLanguage].expired_products,
          data: (
            <Inventories
              {...this.props.routeParams}
              isMainInventory={this.props.isMainInventory}
              onlyExpired
              startExpiredDate={EXPIRED_PRODUCTS_FROM}
              ownStockOnly
            />
          ),
        },
      ];

      // Virtual Stock is superadmin only. Everything whose expiry date has
      // passed, whatever its status — kept separate from Expired Products,
      // which lists only the rows a nightly sweep happened to stamp status
      // "expired": 157 units at one blood bank against 16,220 actually past
      // their date. No status is passed here, the date decides, so a unit
      // appears the moment it expires and nothing has to be moved.
      if (this.state.user?.role === "superAdmin") {
        tabOptions.push({
          title: language[this.props.defaultLanguage].virtual_stock,
          data: (
            <Inventories
              {...this.props.routeParams}
              isMainInventory={this.props.isMainInventory}
              onlyExpired
            />
          ),
        });
      }
    }

    if (canReadProductionInventory) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].inventory_controls,
        data: <Controls {...this.props.routeParams} />,
      });
    }

    return (
      <div>
        <div className="card-dashboard-content">
          <div className="card-body">
            <Tabs options={tabOptions} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(withRouter(InventoriesScreen));
